/**
 * @generated SignedSource<<44fec0d17aab90d3ad12ea7e69e32832>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisableHubspotInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DisableHubspotMutation$variables = {
  input: DisableHubspotInput;
};
export type DisableHubspotMutation$data = {
  readonly disableHubspot: {
    readonly company: {
      readonly hubspotAccountId: string | null;
    } | null;
  } | null;
};
export type DisableHubspotMutation = {
  variables: DisableHubspotMutation$variables;
  response: DisableHubspotMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubspotAccountId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisableHubspotMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableHubspotPayload",
        "kind": "LinkedField",
        "name": "disableHubspot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisableHubspotMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableHubspotPayload",
        "kind": "LinkedField",
        "name": "disableHubspot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "10f874d98fab09999165bdbb545d177b",
    "id": null,
    "metadata": {},
    "name": "DisableHubspotMutation",
    "operationKind": "mutation",
    "text": "mutation DisableHubspotMutation(\n  $input: DisableHubspotInput!\n) {\n  disableHubspot(input: $input) {\n    company {\n      hubspotAccountId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "563e3234041e32dea5192c87319a50ea";

export default node;
